import { QRCodeSVG } from 'qrcode.react';
import { Card } from '@/components/ui/card';
import { format } from 'date-fns';

interface QRData {
  workOrderId: string;
  workOrderNumber: string;
  processId: string;
  processName: string;
  operatorId: string;
  operatorName: string;
  timestamp: string;
  pieceNumber?: string;
}

interface QRGeneratorProps {
  data: QRData;
  size?: number;
  showLabel?: boolean;
}

export const QRGenerator = ({ data, size = 200, showLabel = true }: QRGeneratorProps) => {
  const qrValue = JSON.stringify(data);

  return (
    <Card className="p-6 flex flex-col items-center gap-4">
      <QRCodeSVG
        value={qrValue}
        size={size}
        level="H"
        includeMargin={true}
        bgColor="#ffffff"
        fgColor="#000000"
      />
      
      {showLabel && (
        <div className="text-center space-y-1">
          <p className="font-bold text-foreground">{data.workOrderNumber}</p>
          <p className="text-sm text-muted-foreground">{data.processName}</p>
          <p className="text-xs text-muted-foreground">
            {format(new Date(data.timestamp), 'dd/MM/yyyy HH:mm')}
          </p>
          {data.pieceNumber && (
            <p className="text-xs font-medium text-primary">
              Pieza: {data.pieceNumber}
            </p>
          )}
        </div>
      )}
    </Card>
  );
};
